<template>
  <main class="pt-10 mx-auto container">
    <div class="flex justify-between items-center">
      <img
        :width="200"
        src="@/assets/images/logo.png"
        alt="logo"
      >
    </div>
    <div class="mt-10 mb-20">
      <RouterView />
    </div>
  </main>
</template>